export const langText: any = {
    us: {
        link_coming: 'Coming Soon',
        link_more: 'Learn More',
        link_buy: 'Buy Now',
        link_cart: 'Add to Cart',
        price_prefix: '',
        price_suffix: '',
        off: 'OFF',
        times: 'x',
        point: 'point',
    },
    jp: {
        link_coming: 'もうすぐ発売',
        link_more: '詳しくはこちら',
        link_buy: '今すぐ購入',
        link_cart: 'カートに入れる',
        price_prefix: '通常価格',
        price_suffix: '（税込）',
        off: 'OFF',
        times: '倍',
        point: 'ポイント',
    },
};
